import { render } from "./CommentItem.vue?vue&type=template&id=549296f6&scoped=true&ts=true"
import script from "./CommentItem.ts?vue&type=script&lang=ts"
export * from "./CommentItem.ts?vue&type=script&lang=ts"

import "./CommentItem.scss?vue&type=style&index=0&id=549296f6&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549296f6"]])

export default __exports__